import { Component } from '@angular/core';

@Component({
    selector: 'app-user-avatar',
    template: `<div id="nav-user-avatar"></div>`,
    styles: [
        `
            #nav-user-avatar {
                width: 35px;
                height: 35px;
                border: 2px solid #0083c3;
                border-radius: 35px;
                background: #c4c4c4;
            }
        `,
    ],
})
export class UserAvatarComponent {}
